import React, { useEffect, useRef, useState } from 'react';
import './AboutUs.scss';

const STATS = [
  { value: '10+', label: 'Years of Excellence' },
  { value: '500+', label: 'Happy Clients' },
  { value: '5', label: 'Expert Stylists' },
  { value: '4.9★', label: 'Customer Rating' },
];

const AboutUs = () => {
  const ref = useRef(null);
  const [isInView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
    const el = ref.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  return (
    <section
      ref={ref}
      className={`about${isInView ? ' about--visible' : ''}`}
      aria-label="About Priyaa's Beauty Salon"
    >
      <div className="about__content">
        <span className="about__kicker">Our Story</span>
        <h2 className="about__title">About Priyaa's Salon</h2>
        <div className="about__line" />
        <p className="about__text">
          Priyaa's Salon is a modern beauty studio dedicated to premium hair and skin care,
          blending luxury services with a calm, welcoming atmosphere in the heart of Perambur, Chennai.
        </p>
        <p className="about__text">
          Since 2015, our experienced stylists and skin experts have focused on personalised
          consultations, safe products and techniques that enhance your natural beauty with every visit.
        </p>
        <a href="#contact" className="about__cta">Book a Consultation →</a>
      </div>

      <div className="about__stats-wrap">
        <div className="about__stats">
          {STATS.map(stat => (
            <div className="about__stat" key={stat.label}>
              <span className="about__stat-value">{stat.value}</span>
              <span className="about__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
